import React, {useEffect, useState} from "react";
import {Button, Col, Form, Image, Input as AntInput, Input, Row, Select, Space, Table, Upload} from "antd";
import axios from "axios";
import {getChargePointBasedOnTextSearchResponse, getUsersResponse} from "../../../types/admin";
import {useCredentialStore} from "../../../hooks/useCredentialsStore";
import {useNavigate} from "react-router-dom";
import {getBase64} from "../../../utils/image";
import {PopNotification} from "../../../shared/notification";
import {LoadingSpinner} from "../../../shared/LoadingSpinner";

export const AddMessagePage = () => {

    const navigate = useNavigate();

    const [form] = Form.useForm();
    const [events, setEvents] = useState<any[]>([])
    const [channels, setChannels] = useState<any[]>([])
    const [selectedEvent, setSelectedEvent] = useState<any>()
    const [selectedChannel, setSelectedChannel] = useState<any>()
    const [targets, setTargets] = useState<any[]>([])
    const [selectedTarget, setSelectedTarget] = useState()
    const [channelConfigData, setChannelConfigData] = useState<any>({})
    const [tested, setTested] = useState(false)

    const {token} = useCredentialStore(({token}) => ({
        token
    }));

    useEffect(() => {
        handleGetEvents()
        handleGetChannels()
    }, []);

    useEffect(() => {
        if (!selectedEvent) {
            return;
        }

        if (selectedEvent.code === 'CHARGE_POINT_CHARGER_ONLINE_EVENT') {
            handleGetChargePoints()
        } else if (selectedEvent.code === 'CHARGER_ONLINE_EVENT') {
            handleGetChargers()
        }

    }, [selectedEvent]);

    useEffect(() => {
        setChannelConfigData({})
        setTested(false)

    }, [selectedChannel]);

    const handleGetEvents = () => {
        axios
            .get(`/api/message/event`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                setEvents(res.data)
            })
            .catch((error) => {
                PopNotification("error", error || error?.response?.data?.message || `Something went wrong, ${error.toString()}`);
            })
            .finally(() => {
            });
    };

    const handleGetChannels = () => {
        axios
            .get(`/api/message/channel`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                setChannels(res.data)
            })
            .catch((error) => {
                PopNotification("error", error || error?.response?.data?.message || `Something went wrong, ${error.toString()}`);
            })
            .finally(() => {
            });
    };

    const handleGetChargers = () => {
        axios
            .get(`/api/chargers?page=0&pageSize=200`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                const chargePointList: getChargePointBasedOnTextSearchResponse = res.data;
                setTargets(chargePointList.data);
            })
            .catch((error) => {
                PopNotification("error", error.response.data.message);
            })
    }

    const handleGetChargePoints = () => {
        axios
            .get(`/api/chargePoints?page=0&pageSize=200`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                const chargePointList: getChargePointBasedOnTextSearchResponse = res.data;
                setTargets(chargePointList.data);
            })
            .catch((error) => {
                PopNotification("error", error.response.data.message);
            })
    }


    const handleTestChannel = () => {
        axios
            .post(`/api/message/channel/test`, {
                channel: selectedChannel,
                configJson: JSON.stringify(channelConfigData)
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                setTested(true)

            })
            .catch((error) => {
                setTested(false)
                PopNotification("error", error.response.data.message);
            })
    }


    const handleSaveMessage = () => {

        axios
            .post(`/api/message`, {
                name: form.getFieldValue("name"),
                event: selectedEvent.code,
                targetId: selectedTarget,
                channel: selectedChannel,
                configJson: JSON.stringify(channelConfigData)
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                PopNotification("success", "Create message success!");
                navigate("/admin/messaging");
            })
            .catch((error) => {
                PopNotification("error", error.response.data.message);
            })
    }

    const renderEventData = (event: any) => {
        if (!event || !event?.code) {
            return <></>
        }

        console.log(targets)

        if (event.code === 'CHARGE_POINT_CHARGER_ONLINE_EVENT') {

            return <Form.Item
                name="targetId"
                label="Charge Point"
            >
                <Select onChange={(value) => {
                    setSelectedTarget(value)
                }}>
                    {
                        targets?.map((data) => {
                            return <Select.Option key={data.id.id} value={data.id.id}>{data.name}</Select.Option>
                        })
                    }
                </Select>
            </Form.Item>
        } else if (event.code === 'CHARGER_ONLINE_EVENT') {

            return <Form.Item
                name="targetId"
                label="Charger"
            >
                <Select
                    onChange={(value) => {
                        setSelectedTarget(value)
                    }}
                >
                    {
                        targets?.map((data) => {
                            return <Select.Option key={data.id.id} value={data.id.id}>{data.uniqueId}</Select.Option>
                        })
                    }
                </Select>
            </Form.Item>
        } else {
            return <span></span>
        }
    }

    const renderChannelConfigData = () => {
        if (selectedChannel === 'telegramMessageChannel') {
            return <>
                <Form.Item
                    label="Token"
                    name="token"
                >
                    <Input
                        onChange={(e) => setChannelConfigData((prev: any) => ({
                            ...prev,
                            token: e.target.value
                        }))}

                        placeholder="token"></Input>
                </Form.Item>
                <Form.Item
                    label="ChatId"
                    name="chatId"
                >
                    <Input
                        onChange={(e) => setChannelConfigData((prev: any) => ({
                            ...prev,
                            chatId: e.target.value
                        }))}
                        placeholder="chatId"></Input>
                </Form.Item>
                <Form.Item
                    label="Uptime Debounce (s)"
                    name="uptimeDebounce"
                >
                    <Input
                        onChange={(e) => setChannelConfigData((prev: any) => ({
                            ...prev,
                            uptimeDebounce: e.target.value
                        }))}
                        type="number"
                        placeholder="0"></Input>
                </Form.Item>
                <Form.Item
                    label="Downtime Debounce (s)"
                    name="downtimeDebounce"
                >
                    <Input
                        onChange={(e) => setChannelConfigData((prev: any) => ({
                            ...prev,
                            downtimeDebounce: e.target.value
                        }))}
                        type="number"
                        placeholder="0"></Input>
                </Form.Item>
            </>
        }
    }

    return (
        <Space direction={"vertical"} style={{width: '100%'}}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <span className='page-title'>Add Message</span>


            </div>

            <Form form={form}
                  layout="vertical"
            >
                <div>
                    <Form.Item
                        label="Name"
                        name="name"
                    >
                        <Input placeholder="Name"></Input>
                    </Form.Item>
                    <span className='id-css'>Event</span>
                    <Form.Item
                        name="event"
                        label="Event"
                    >
                        <Select onChange={(value) => {
                            setSelectedEvent(events.filter(x => x.code === value)[0])
                        }}>
                            {
                                events?.map((data) => {
                                    return <Select.Option key={data.code} value={data.code}>{data.name}</Select.Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                    {selectedEvent && renderEventData(selectedEvent)}
                    {selectedEvent && <>
                        <div style={{
                            display: "flex",
                            flexDirection: "column"
                        }}>
                            <span>Description</span>
                            <span>{selectedEvent.description}</span>

                            <span>Example</span>
                            <span>{selectedEvent.sample}</span>
                        </div>
                    </>

                    }
                    <span className='id-css'>Channel</span>
                    <Form.Item
                        name="channel"
                        label="Channel"
                    >
                        <Select onChange={(value) => {
                            setSelectedChannel(value)
                        }}>
                            {
                                channels?.map((data) => {
                                    return <Select.Option key={data} value={data}>{data}</Select.Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                    {selectedChannel && renderChannelConfigData()}
                    {selectedChannel && <>
                        <div>
                                            <span onClick={() => {
                                                handleTestChannel()
                                            }} style={{
                                                backgroundColor: "#39B64B",
                                                padding: "5px 15px",
                                                cursor: "pointer",
                                                color: "white",
                                                borderRadius: 7,
                                                display: "inline-block",
                                                textTransform: "uppercase",
                                                marginRight: 10
                                            }}>
                                                Test
                        </span>

                        </div>
                    </>}

                </div>

            </Form>


            {
                tested &&
                <div>
                <span onClick={() => {
                    handleSaveMessage()
                }} style={{
                    backgroundColor: "#39B64B",
                    padding: "5px 15px",
                    cursor: "pointer",
                    color: "white",
                    borderRadius: 7,
                    display: "inline-block",
                    textTransform: "uppercase",
                    marginRight: 10
                }}>
            Save
        </span>

                </div>
            }

        </Space>
    )
}
